import { t } from 'i18next'
import type { ButtonSetDefinition, SuggestionButton } from '@/scenes/Editor/components/EditWithAI/components/suggestedButtonSets'
import type { VideoSuggestionsData } from '../hooks/useVideoSuggestions'

const EMPTY_SUGGESTIONS: VideoSuggestionsData = { items: [], isLoading: false }

/** Generated titles are already localized; a click passes the full prompt to the draft. */
export const aiStudioVideoButtonSet: ButtonSetDefinition<VideoSuggestionsData> = {
  key: 'aiStudioVideo',
  useData: (_activeObject, override) => override?.videoSuggestions ?? EMPTY_SUGGESTIONS,
  getButtons: ({ items, isLoading, loadMore }): SuggestionButton[] => [
    ...items.map(item => ({ title: item.title, value: item.prompt })),
    ...(!isLoading && loadMore ? [{ title: t(items.length ? 'More' : 'Try again'), onClick: loadMore }] : []),
  ],
}
